import { render, staticRenderFns } from "./TableDownload.vue?vue&type=template&id=141c6ba2&scoped=true&"
import script from "./TableDownload.vue?vue&type=script&lang=js&"
export * from "./TableDownload.vue?vue&type=script&lang=js&"
import style0 from "./TableDownload.vue?vue&type=style&index=0&id=141c6ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141c6ba2",
  null
  
)

export default component.exports